import React, { useState, useEffect } from "react";
import { getAtdlist, addSes } from './api/ApiAtd';
import {
    Link
} from "react-router-dom";
import DatePicker from "./Date";
const ArticleCard = ({ article }) => {
    return (
        <div className="my-2 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">
            <Link to={"/attendance/" + article._id}>
                <article className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl ease-in duration-50 cursor-pointer">
                    <div className='flex items-center justify-center bg-white h-40'>
                        <svg width="60px" height="60px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 12H15" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 16H15" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <circle cx="9" cy="12" r="1" fill="#000000" />
                            <circle cx="9" cy="16" r="1" fill="#000000" />
                        </svg>
                    </div>

                    <header className="flex items-center justify-between leading-tight p-2 md:p-4">
                        <h1 className="text-lg ml-1">
                            <p className="no-underline font-medium text-black">
                                {article.title}
                            </p>
                        </h1>
                        <div className="flex items-center">
                            <p className="text-grey-darker text-sm mr-2">{(article.sesStart)}</p>
                            {/* <div className="py-2 px-2 rounded-full mr-1 hover:bg-slate-200 cursor-pointer ">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                </svg>
                            </div> */}
                        </div>
                    </header>
                </article></Link>
        </div>
    );
};
export default function AtdList({ data }) {
    const [articles, setArticles] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState("");
    const [showSesSubmitLoad, setShowSesSubmitLoad] = useState(false);
    const [sestitle, setSestitle] = useState('');
    useEffect(() => {
    })
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };
    const closeModal = (e) => {
        // Close modal if clicked outside the modal content
        if (e.target.id === "authentication-modal") {
            setIsModalOpen(false);
        }
    };
    const handleRegister = async () => {
        if (sestitle.length <= 0 || !selectedDate) {
            alert("Please fill the title");
            return;
        }
        setShowSesSubmitLoad(true);
        try {
            const response = await addSes(sestitle, selectedDate);
            if (response.data.success) {
                setArticles((prevArticles) => [...prevArticles, response.data.atdSes]);
            }
        } catch (error) {
            alert(error)
        } finally {
            setShowSesSubmitLoad(false);
            setIsModalOpen(false); // Set loading to false once data is fetched
        }
    };



    // Fetch articles from API
    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const response = await getAtdlist();
                console.log(response);
                setArticles(response.data.seslist); // Assuming data is an array of articles
            } catch (error) {
                console.error("Error fetching articles:", error);
            } finally {
                setLoading(false); // Set loading to false once data is fetched
            }
        };

        fetchArticles();
    }, []);

    if (loading) {
    return <>
        <div className="flex items-center justify-between m-4">
            <div className="relative h-10 w-40 rounded-lg overflow-hidden">
                <div className="skeleton"></div>
            </div>
            <div className="relative h-10 w-40 rounded-lg overflow-hidden">
                <div className="skeleton"></div>
            </div>
        </div>
        <div>
            <div className="container my-2 mx-auto px-4">
                <div className="flex flex-wrap -mx-1 lg:-mx-4">
                    <div className="my-2 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">
                        <article className="overflow-hidden h-48 relative rounded-lg ">
                            <div className="skeleton"></div>
                        </article></div><div className="my-2 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">
                        <article className="overflow-hidden h-48 relative rounded-lg ">
                            <div className="skeleton"></div>
                        </article></div><div className="my-2 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">
                        <article className="overflow-hidden h-48 relative rounded-lg ">
                            <div className="skeleton"></div>
                        </article></div>
                </div>
            </div>
        </div>

    </>;
    }
    return (
        <>
            <div className="flex items-center justify-between m-4">
                <h2 className="text-l font-bold text-gray-800">Attendance Corner</h2>

                <button onClick={toggleModal} className="shadow inline-flex items-center bg-blue-500 hover:bg-blue-600 focus:outline-none focus:shadow-outline text-white font-semibold w-40 py-2 px-3 text-sm rounded-lg">
                    <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 w-5 h-5" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="0" y="0" width="24" height="24" stroke="none" />
                        <line x1="12" y1="5" x2="12" y2="19" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                    Create Session
                </button>
            </div>
            <div>
                <div className="container my-2 mx-auto px-4">
                    <div className="flex flex-wrap -mx-1 lg:-mx-4">
                        {articles.length === 0 ? (<>

                            <div className="my-2 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">
                                <article onClick={toggleModal} className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl ease-in duration-50 cursor-pointer">
                                    <div className='flex items-center justify-center bg-white h-40'>

                                        <svg width="60px" height="60px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M17 15V18M17 21V18M17 18H14M17 18H20" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>

                                    <header className="flex items-center justify-between leading-tight p-2 md:p-4">
                                        <h1 className="text-lg ml-1">
                                            <p className="no-underline font-medium text-black flex items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 w-5 h-5" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                    <rect x="0" y="0" width="24" height="24" stroke="none" />
                                                    <line x1="12" y1="5" x2="12" y2="19" />
                                                    <line x1="5" y1="12" x2="19" y2="12" />
                                                </svg> Create New Session
                                            </p>
                                        </h1>
                                    </header>
                                </article>
                            </div>
                        </>) : (<>
                            {articles.map((article, index) => (
                                <ArticleCard key={index} article={article} />
                            ))}

                        </>)}

                    </div>
                </div>
            </div>

            {isModalOpen && (
                <div
                    onClick={closeModal}
                    id="authentication-modal"
                    aria-hidden={!isModalOpen}
                    className="fixed h-modal md:h-full top-4 left-0 right-0 md:inset-0 z-50 flex justify-center items-center"
                >
                    <div className="relative w-full max-w-md px-4 h-full md:h-auto">
                        {/* Modal Content */}
                        <div className="bg-white rounded-lg shadow relative">
                            {/* Close Button */}
                            <div className="flex justify-end p-2">
                                <button
                                    type="button"
                                    onClick={toggleModal}
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
                                >
                                    <svg
                                        className="w-5 h-5"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                            clipRule="evenodd"
                                        ></path>
                                    </svg>
                                </button>
                            </div>
                            {/* Modal Form */}
                            <div className="space-y-6 px-6 lg:px-8 pb-4 sm:pb-6 xl:pb-8" action="#">
                                <h3 className="text-xl font-medium text-gray-900">
                                    Create New Sessiom
                                </h3>
                                <div>
                                    <label
                                        htmlFor="email"
                                        className="text-sm font-medium text-gray-900 block mb-2"
                                    >
                                        Enter title
                                    </label>
                                    <input
                                        onChange={(e) => setSestitle(e.target.value)}
                                        name="Title"
                                        className="border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                        placeholder="title here..."
                                    />
                                </div>
                                <div>
                                    <label
                                        htmlFor="password"
                                        className="text-sm font-medium text-gray-900 block mb-2"
                                    >
                                        Session Start Date
                                    </label>
                                    <DatePicker onChange={(date) => setSelectedDate(date)} />
                                </div>
                                <button
                                    onClick={handleRegister}
                                    type="submit"
                                    className="items-center flex w-full text-white bg-blue-500 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                >
                                    {showSesSubmitLoad ? (<>
                                        <div class="w-4 h-4 rounded-full animate-spin border-2 border-solid border-white border-t-transparent mr-2"></div>
                                        Creating Session...
                                    </>) : (<>
                                        Create Session
                                    </>)}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>)}
        </>
    )
}
